// packages/eden-styled-helpers/src/index.js
import { css } from "styled-components";
import {
  breakWidth480,
  breakWidth600,
  breakWidth840,
  breakWidth960,
  breakWidth1280,
  breakWidth1440,
  breakWidth1600
} from "@churchofjesuschrist/eden-style-constants";
var mediaBreak480w = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth480}) {
    ${css(...args)};
  }
`;
var mediaBreak600w = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth600}) {
    ${css(...args)};
  }
`;
var mediaBreak840w = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth840}) {
    ${css(...args)};
  }
`;
var mediaBreak960w = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth960}) {
    ${css(...args)};
  }
`;
var mediaBreak1280w = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth1280}) {
    ${css(...args)};
  }
`;
var mediaBreak1440w = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth1440}) {
    ${css(...args)};
  }
`;
var mediaBreak1600w = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth1600}) {
    ${css(...args)};
  }
`;
var mediaBreakGutter = (...args) => css`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media (min-width: ${breakWidth600}) and (min-height: ${breakWidth600}) {
    ${css(...args)};
  }
`;
var dir = (theDir) => (...args) => css`
    [dir="${theDir}"] &,
    &[dir="${theDir}"] {
      ${css(...args)};
    }
  `;
export {
  dir,
  mediaBreak1280w,
  mediaBreak1440w,
  mediaBreak1600w,
  mediaBreak480w,
  mediaBreak600w,
  mediaBreak840w,
  mediaBreak960w,
  mediaBreakGutter
};
